import { MutationTree } from 'vuex';
import { ASSET } from '../mutation_types';
import { IASSETSTATE } from '../state.d';

const state: IASSETSTATE = {
  manage: {
    removeData: [],
    removeFlag: false,
  },
  category: {
    listFlag: false,
  },
};

/* eslint-disable no-param-reassign */
const mutations: MutationTree<IASSETSTATE> = {
  [ASSET.SET_ASSET_MANAGE_REMOVE_DATA]: (s, data: Array<any>) => {
    s.manage.removeData = data;
  },
  [ASSET.SET_ASSET_MANAGE_REMOVE_FLAG]: (s, flag: boolean) => {
    s.manage.removeFlag = flag;
  },
  [ASSET.SET_ASSET_CATEGORY_LIST_FLAG]: (s, flag: boolean) => {
    s.category.listFlag = flag;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
